module.exports = __webpack_public_path__ + "img/cases-part1-9.e78d8d27.png";